module.exports = __webpack_public_path__ + "img/index8.44466f1f.png";